import styled from '@emotion/styled/macro';
import { TableCell, tableCellClasses, TableRow } from '@mui/material';
import { colors } from '@assets/colors';

export const TableCellStyled = styled(TableCell)(() => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: colors.gray2,
        color: colors.black0
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14
    }
}));

export const TableRowStyled = styled(TableRow)(() => ({
    transition: 'all 300ms',
    '&:hover': {
        cursor: 'pointer',
        backgroundColor: colors.gray2
    },
    '&:active': {
        backgroundColor: colors.white1
    },
    '&:nth-of-type(odd)': {
        backgroundColor: colors.white1,
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: colors.gray2
        },
        '&:active': {
            backgroundColor: colors.white1
        }
    },
    '&:last-child td, &:last-child th': {
        border: 0
    }
}));
